import { render, staticRenderFns } from "./TwoUp.vue?vue&type=template&id=331cb4e6&scoped=true&"
import script from "./TwoUp.vue?vue&type=script&lang=js&"
export * from "./TwoUp.vue?vue&type=script&lang=js&"
import style0 from "./TwoUp.vue?vue&type=style&index=0&id=331cb4e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331cb4e6",
  null
  
)

export default component.exports